// @flow
import React, { type Node } from "react";
import { get } from "lodash";
import Container from "./styled-components";

type Props = {
  children: Node,
  extraOffset: number
};

const ShadowScrollContainer = (props: Props) => {
  // $FlowFixMe
  const innerRef = React.useRef(null);
  // $FlowFixMe
  const [isOverflowing, setOverflowing] = React.useState(false);
  // $FlowFixMe
  React.useEffect(() => {
    const innerHeight = get(innerRef, "current.clientHeight", 0);
    const innerOffsetTop = get(innerRef, "current.offsetTop", 0);
    const parentHeight = get(innerRef, "current.offsetParent.clientHeight", 0);

    setOverflowing(
      innerHeight + innerOffsetTop > parentHeight - props.extraOffset
    );
  }, []);

  return (
    <Container shadowVisible={isOverflowing}>
      <div ref={innerRef}>{props.children}</div>
    </Container>
  );
};

ShadowScrollContainer.defaultProps = {
  extraOffset: 0
};

export default ShadowScrollContainer;
